import React from "react";
import RegionInput from "./RegionInput";
import DenominationInput from "./DenominationInput";
import AttendanceInput from "./AttendanceInput";
import AttendanceRangeInput from "./AttendanceRangeInput";
import GivingRangeInput from "./GivingRangeInput";
import ConversionsInput from "./ConversionsInput";
import ContactsInput from "./ContactsInput";
import StaffSizeInput from "./StaffSizeInput";
import TextInput from "../../lib/TextInput";

const NumberInput = (props) => <TextInput type="number" {...props} autoFocus />;

export default [
  {
    id: 101,
    title: "Church Name",
    placeholder: "Enter your church’s name",
    component: TextInput,
  },
  {
    id: 102,
    title: "Church Location",
    component: RegionInput,
  },
  {
    id: 103,
    title: "Church Denomination",
    component: DenominationInput,
  },
  {
    id: 104,
    title: "Church Attendance",
    description:
      "Please use the current month as a starting point and, working backwards, calculate your church’s average attendance (including children) for the last three years.",
    component: AttendanceRangeInput,
    validator: (value) => {
      return (
        value &&
        value.one !== undefined &&
        value.two !== undefined &&
        value.three !== undefined
      );
    },
  },
  {
    id: 104.1, // replaces range input for church attendance
    title: "Please select your church’s average attendance.",
    component: AttendanceInput,
  },
  {
    id: 104.5,
    title: "Church Staff Size",
    description: "",
    component: StaffSizeInput,
  },
  {
    id: 105,
    title: "Church Giving*",
    description: "*We don’t share this information with anyone",
    label: "Conversions during the last 12 months",
    component: GivingRangeInput,
    validator: (value) => {
      return (
        value &&
        value.one !== undefined &&
        value.two !== undefined &&
        value.three !== undefined
      );
    },
  },
  {
    id: 106,
    title: "Church Conversions",
    description:
      "Please use the current month as a starting point and, working backwards, indicate the total number of conversions your church has experienced during the last 12 months.",
    label: "Conversions during the last 12 months",
    component: NumberInput,
  },
  {
    id: 106.5, // replaces single input for church conversions
    title: "Church Conversions",
    description:
      "Please use the current month as a starting point and, working backwards, indicate the total number of conversions your church has experienced during the last 12 months.",
    label: "Conversions",
    component: ConversionsInput,
    validator: (value) => {
      return value && value.one !== undefined && value.two !== undefined;
    },
  },
  {
    id: 107,
    title: "New Contacts",
    description:
      "Please use the current month as a starting point and, working backwards, indicate the total number of new people that have been added to your church database during the last 12 months.",
    label: "Contacts",
    component: ContactsInput,
    validator: (value) => {
      return value && value.one !== undefined && value.two !== undefined;
    },
  },
];



// WEBPACK FOOTER //
// ./src/assess/question/questions_demograph.js